import PropTypes from 'prop-types'
import { gql } from '@apollo/client'

const bundledTicketsFragment = gql`
  fragment bundledTicketsEventType on EventTypeBundledTickets {
    amount
  }
`

export const bundledTicketsPropTypes = PropTypes.shape({
  amount: PropTypes.number.isRequired,
})

export default bundledTicketsFragment
